// extracted by mini-css-extract-plugin
export default {"block":"rFIQg","readOnlyBlock":"RIJwk","rulesText":"OodBW","caption":"mmohO","captionLine":"khxAO","errorText":"mvwwU"};